module.exports = __webpack_public_path__ + "img/hover-iocn4.ef39e118.svg";